import React, { useCallback, useContext } from 'react'

import LightBox from 'components/Luxkit/Modal/LightBox'
import Modal from 'components/Luxkit/Modal/Modal'
import ModalContext from 'contexts/ModalContext'
import { last } from 'lib/array/arrayUtils'
import DocumentImageView from 'tripPlanner/components/Documents/DocumentImageView'
import DocumentPdfView from 'tripPlanner/components/Documents/DocumentPdfView'
import { TripDocument } from 'tripPlanner/types/documents'

export default function useViewDocument(document: TripDocument) {
  const showModal = useContext(ModalContext)

  const showDocument = useCallback(() => {
    const fileType = last(document.key.split('.'))
    if (fileType === 'pdf') {
      showModal(
        <Modal title={document.filename} size="max" height="full">
          <DocumentPdfView documentKey={document.key} />
        </Modal>,
      )
    } else {
      showModal(
        <LightBox>
          <DocumentImageView
            documentKey={document.key}
            filename={document.filename}
          />
        </LightBox>,
      )
    }
  }, [document.filename, document.key, showModal])

  return showDocument
}
